import * as React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, Chip, TableCell, TableRow } from "@mui/material";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import InfoIcon from "@mui/icons-material/Info";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

export function RowsTableMemberships(props) {
  const {
    row,
    setShowModalMembership,
    setSelectedMembership,
    setShowModalMembershipDetails,
    setShowModalDeleteMembership,
    setShowModalActivateMembership,
  } = props;
  const [open, setOpen] = React.useState(false);
 
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.planName ?? ""}
        </TableCell>
        <TableCell align="center">$ {row?.price ?? ""}</TableCell>
        <TableCell align="center">
          <Chip
            label={row?.active ? "Activa" : "Inactiva "}
            style={{
              backgroundColor: row?.active
                ? "rgb(5,193,104,20%)"
                : "rgba(255,90,101,20%)",
              color: row?.active ? "#14CA74" : "#FF5A65",
            }}
          />
        </TableCell>
        <TableCell align="center">
          {row?.typeUser === "user"
            ? "Usuario Runner"
            : "Prestador de servidor"}
        </TableCell>
        <TableCell align="center">{row?.routeLimit ?? ""}</TableCell>
        <TableCell align="center">{row?.platform  ? row?.platform[0] : "STRIPE"}</TableCell>

      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  onClick={() => {
                    setSelectedMembership(row);
                    setShowModalMembershipDetails(true);
                  }}
                  startIcon={<InfoIcon />}
                >
                  Detalles
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  startIcon={<BorderColorIcon />}
                  onClick={() => {
                    setSelectedMembership(row);
                    setShowModalMembership(true);
                  }}
                >
                  Editar
                </Button>
                {row?.active ? (
                  <Button
                    variant="outlined"
                    color="white"
                    startIcon={<DeleteForeverIcon />}
                    onClick={() => {
                      setSelectedMembership(row);
                      setShowModalDeleteMembership(true);
                    }}
                  >
                    Desactivar Producto
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    color="white"
                    startIcon={<CreditScoreIcon />}
                    onClick={() => {
                      setSelectedMembership(row);
                      setShowModalActivateMembership(true);
                    }}
                  >
                    Activar Producto
                  </Button>
                )}
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
